import { Injectable } from '@angular/core';

@Injectable() // 'VG_HLS_SUPPORT'
export class VgHlsSupportService {
	public isMSE: boolean;
	public isNative: boolean;

	constructor() {
		const isSourceBuffer: boolean = window.SourceBuffer || (window as any).WebKitSourceBuffer || (window as any).ManagedSourceBuffer;
		const isMediaSource: boolean = window.MediaSource || (window as any).WebKitMediaSource || (window as any).ManagedMediaSource;

		this.isMSE = isSourceBuffer && isMediaSource; // simplified check as an alternative to the util in hls.js to support dynamic import
		this.isNative = this.checkNativeSupport();
	}

	private checkNativeSupport(): boolean {
		const canPlayVnd: boolean = this.canPlay('application/vnd.apple.mpegURL');
		const canPlayXmpeg: boolean = this.canPlay('application/x-mpegURL');

		return canPlayVnd || canPlayXmpeg;
	}

	private canPlay(canPlayType: string): boolean {
		const videoElement: HTMLVideoElement = document.createElement('video');
		const isNativelySupportedRegex = /probably|maybe/;

		return videoElement.canPlayType && isNativelySupportedRegex.test(videoElement.canPlayType(canPlayType));
	}
}
